import React from "react";
import "../fashion.css";

import Header from "../../../components/Header";
import Footer from "../../../components/Footer";

import { NavLink } from "react-router-dom";

import {
    FiHome,
    FiChevronRight,
    FiShoppingBag,
} from "react-icons/fi";


const Fashion = () => {

    return (

        <>

            <Header />



            {/* =====================================================
                            HERO SECTION
            ===================================================== */}



            <section className="fashion-hero">


                <div className="fashion-overlay"></div>



                <div className="container">



                    <div className="fashion-hero-content">





                        <span className="fashion-tag">

                            Fashion Technology Solutions

                        </span>






                        <h1>


                            Transforming
                            <span> Fashion Business </span>
                            Through Smart Digital Innovation


                        </h1>







                        <p>


                            Kishancart Digital (OPC) Private Limited
                            provides innovative digital solutions for
                            fashion brands, apparel retailers, clothing
                            businesses, manufacturers, and online fashion
                            marketplaces. We build smart fashion platforms
                            that improve inventory management, customer
                            experience, online sales, and business growth
                            through modern technology.



                        </p>






                        <div className="fashion-hero-btns">



                            {/*

                            <NavLink
                                to="/contact"
                                className="primary-btn"
                            >

                                Contact Experts

                            </NavLink>




                            <NavLink
                                to="/services"
                                className="secondary-btn"
                            >

                                Explore Solutions

                            </NavLink>

                            */}



                        </div>





                    </div>




                </div>




            </section>









            {/* =====================================================
                            BREADCRUMB
            ===================================================== */}





            <section className="fashion-breadcrumb">


                <div className="container">



                    <div className="breadcrumb">





                        <NavLink to="/">


                            <FiHome />

                            Home


                        </NavLink>






                        <FiChevronRight />






                        <span>

                            Solutions

                        </span>






                        <FiChevronRight />







                        <span className="active">


                            <FiShoppingBag />

                            Fashion


                        </span>





                    </div>




                </div>




            </section>









            {/* =====================================================
                    FASHION OVERVIEW
            ===================================================== */}





            <section className="fashion-overview">



                <div className="container">






                    <div className="overview-grid">







                        {/* LEFT CONTENT */}





                        <div className="overview-content">





                            <span className="section-tag">


                                Digital Fashion Solutions


                            </span>







                            <h2>


                                Smart Technology for
                                <span> Modern Fashion Business</span>


                            </h2>








                            <p>


                                Kishancart Digital (OPC) Private Limited
                                develops secure and scalable fashion
                                technology solutions that help fashion
                                brands, retailers, manufacturers, and
                                online stores manage their complete
                                business operations digitally.



                            </p>








                            <p>



                                Our fashion platforms simplify product
                                management, inventory control, online
                                shopping, customer engagement, order
                                processing, and analytics to create a
                                complete digital fashion ecosystem.



                            </p>









                            <div className="overview-list">





                                <div className="overview-item">


                                    ✓ Fashion Store Management System


                                </div>








                                <div className="overview-item">


                                    ✓ Online Fashion Marketplace


                                </div>








                                <div className="overview-item">


                                    ✓ Product & Inventory Management


                                </div>








                                <div className="overview-item">


                                    ✓ Order & Delivery Management


                                </div>








                                <div className="overview-item">


                                    ✓ Customer Relationship Management


                                </div>








                                <div className="overview-item">


                                    ✓ Fashion Analytics Dashboard


                                </div>







                            </div>






                        </div>









                        {/* RIGHT CARDS */}





                        <div className="overview-cards">







                            <div className="overview-card">



                                <h3>


                                    Fashion Store Management


                                </h3>






                                <p>


                                    Manage clothing products,
                                    collections, inventory, pricing,
                                    customers, and daily fashion
                                    business operations from one
                                    centralized platform.


                                </p>





                            </div>









                            <div className="overview-card">



                                <h3>


                                    Online Fashion Platform


                                </h3>






                                <p>


                                    Create modern fashion shopping
                                    platforms with product catalogs,
                                    online ordering, payments, and
                                    personalized shopping experiences.


                                </p>





                            </div>









                            <div className="overview-card">



                                <h3>


                                    Inventory Automation


                                </h3>






                                <p>


                                    Track fashion products, sizes,
                                    colors, stock availability, and
                                    seasonal collections with smart
                                    inventory solutions.


                                </p>





                            </div>









                            <div className="overview-card">



                                <h3>


                                    Fashion Business Analytics


                                </h3>






                                <p>


                                    Analyze sales performance,
                                    customer preferences, product
                                    trends, and business growth
                                    through real-time dashboards.


                                </p>





                            </div>






                        </div>







                    </div>







                </div>






            </section>






            {/*

                PART 2 STARTS HERE

                Fashion Challenges
                +
                Fashion Solutions

            */}

{/* =====================================================
        FASHION INDUSTRY CHALLENGES
===================================================== */}


<section className="fashion-challenges">


    <div className="container">


        <div className="section-heading">


            <span className="section-tag">

                Industry Challenges

            </span>



            <h2>

                Challenges in
                <span> Modern Fashion Business Management</span>

            </h2>



            <p>

                Fashion businesses face challenges related to inventory
                management, changing customer preferences, supply chain
                visibility, online sales growth, and operational efficiency.
                Our digital fashion solutions help brands overcome these
                challenges with smart technology.

            </p>



        </div>





        <div className="challenge-grid">



            <div className="challenge-card">


                <h3>

                    Inventory Management

                </h3>


                <p>

                    Manage fashion products, sizes, colors, collections,
                    stock availability, and warehouse operations through
                    an integrated digital inventory system.

                </p>


            </div>






            <div className="challenge-card">


                <h3>

                    Customer Experience

                </h3>


                <p>

                    Deliver personalized shopping experiences with
                    customer insights, recommendations, loyalty programs,
                    and digital engagement solutions.

                </p>


            </div>






            <div className="challenge-card">


                <h3>

                    Fashion Supply Chain

                </h3>


                <p>

                    Improve supply chain visibility from manufacturing
                    and sourcing to distribution and final customer
                    delivery.

                </p>


            </div>






            <div className="challenge-card">


                <h3>

                    Online Fashion Growth

                </h3>


                <p>

                    Build scalable fashion e-commerce platforms to
                    increase online sales, manage orders, and reach
                    customers across multiple channels.

                </p>


            </div>






            <div className="challenge-card">


                <h3>

                    Trend Management

                </h3>


                <p>

                    Analyze fashion trends, customer preferences,
                    and market demands to make better business
                    decisions.

                </p>


            </div>






            <div className="challenge-card">


                <h3>

                    Operational Automation

                </h3>


                <p>

                    Automate product management, reporting, order
                    processing, and business workflows to improve
                    operational efficiency.

                </p>


            </div>




        </div>



    </div>


</section>








{/* =====================================================
        FASHION DIGITAL SOLUTIONS
===================================================== */}



<section className="fashion-solutions">


    <div className="container">



        <div className="section-heading">


            <span className="section-tag">

                Our Fashion Solutions

            </span>





            <h2>

                Complete Digital Solutions for
                <span> Fashion Industry</span>

            </h2>





            <p>

                We develop smart, scalable, and customer-focused
                technology solutions that help fashion brands,
                retailers, manufacturers, and marketplaces improve
                efficiency and accelerate growth.

            </p>



        </div>







        <div className="solutions-grid">






            <div className="solution-card">


                <h3>

                    Fashion E-Commerce Platform

                </h3>


                <p>

                    Create powerful online fashion stores with
                    product catalogs, shopping carts, payments,
                    order management, and customer accounts.

                </p>


            </div>







            <div className="solution-card">


                <h3>

                    Fashion Inventory Management

                </h3>


                <p>

                    Manage products, categories, sizes, colors,
                    collections, stock levels, and warehouse
                    operations efficiently.

                </p>


            </div>







            <div className="solution-card">


                <h3>

                    Retail Management System

                </h3>


                <p>

                    Digitally manage fashion stores, billing,
                    sales tracking, customer management, and
                    business operations.

                </p>


            </div>







            <div className="solution-card">


                <h3>

                    Customer Relationship Management

                </h3>


                <p>

                    Improve customer engagement using customer
                    data, loyalty programs, personalized offers,
                    and marketing automation.

                </p>


            </div>







            <div className="solution-card">


                <h3>

                    Fashion Marketplace

                </h3>


                <p>

                    Build multi-vendor fashion marketplaces
                    connecting brands, sellers, and customers
                    through a single digital platform.

                </p>


            </div>







            <div className="solution-card">


                <h3>

                    Order & Delivery Management

                </h3>


                <p>

                    Streamline order processing, shipping,
                    tracking, returns, and delivery operations
                    with automation.

                </p>


            </div>







            <div className="solution-card">


                <h3>

                    Fashion Analytics Dashboard

                </h3>


                <p>

                    Analyze sales performance, customer behavior,
                    inventory movement, and business growth
                    through real-time dashboards.

                </p>


            </div>







            <div className="solution-card">


                <h3>

                    Mobile Fashion Applications

                </h3>


                <p>

                    Provide customers with mobile shopping apps
                    offering seamless browsing, ordering, and
                    personalized fashion experiences.

                </p>


            </div>





        </div>



    </div>


</section>

{/* =====================================================
        FASHION FEATURES
===================================================== */}


<section className="fashion-features">


    <div className="container">



        <div className="section-heading">


            <span className="section-tag">

                Key Features

            </span>




            <h2>

                Powerful Features for a
                <span> Modern Fashion Platform</span>

            </h2>




            <p>

                Our fashion technology solutions provide advanced
                features that help brands, retailers, and fashion
                businesses manage products, customers, sales,
                and operations efficiently.

            </p>



        </div>








        <div className="features-grid">





            <div className="feature-card">

                <h3>

                    Fashion E-Commerce Store

                </h3>

            </div>





            <div className="feature-card">

                <h3>

                    Product Catalog Management

                </h3>

            </div>





            <div className="feature-card">

                <h3>

                    Size & Color Management

                </h3>

            </div>





            <div className="feature-card">

                <h3>

                    Inventory Tracking System

                </h3>

            </div>





            <div className="feature-card">

                <h3>

                    Order Management

                </h3>

            </div>





            <div className="feature-card">

                <h3>

                    Customer Management

                </h3>

            </div>





            <div className="feature-card">

                <h3>

                    Fashion Marketplace

                </h3>

            </div>





            <div className="feature-card">

                <h3>

                    Payment Integration

                </h3>

            </div>





            <div className="feature-card">

                <h3>

                    Delivery Tracking

                </h3>

            </div>





            <div className="feature-card">

                <h3>

                    Sales Analytics Dashboard

                </h3>

            </div>





            <div className="feature-card">

                <h3>

                    Marketing Automation

                </h3>

            </div>





            <div className="feature-card">

                <h3>

                    Secure Cloud Platform

                </h3>

            </div>





        </div>



    </div>



</section>









{/* =====================================================
        BUSINESS BENEFITS
===================================================== */}



<section className="fashion-benefits">


    <div className="container">





        <div className="section-heading">


            <span className="section-tag">

                Business Benefits

            </span>





            <h2>

                Why Fashion Businesses Choose
                <span> Kishancart Digital</span>

            </h2>





            <p>

                Our fashion technology solutions help brands,
                retailers, and manufacturers improve customer
                experience, increase sales, automate operations,
                and build scalable digital fashion ecosystems.

            </p>



        </div>








        <div className="benefits-grid">






            <div className="benefit-card">


                <h3>

                    Increased Online Sales

                </h3>


                <p>

                    Grow fashion sales through powerful
                    e-commerce platforms, mobile apps,
                    and digital customer experiences.

                </p>


            </div>







            <div className="benefit-card">


                <h3>

                    Better Inventory Control

                </h3>


                <p>

                    Manage products, stock levels, sizes,
                    colors, and collections with accurate
                    inventory visibility.

                </p>


            </div>







            <div className="benefit-card">


                <h3>

                    Improved Customer Experience

                </h3>


                <p>

                    Deliver personalized shopping experiences
                    with customer insights, recommendations,
                    and loyalty solutions.

                </p>


            </div>







            <div className="benefit-card">


                <h3>

                    Operational Efficiency

                </h3>


                <p>

                    Automate fashion business processes
                    including orders, inventory, reporting,
                    and customer management.

                </p>


            </div>







            <div className="benefit-card">


                <h3>

                    Data-Driven Decisions

                </h3>


                <p>

                    Use real-time analytics and business
                    insights to understand trends and
                    improve decision making.

                </p>


            </div>







            <div className="benefit-card">


                <h3>

                    Scalable Fashion Growth

                </h3>


                <p>

                    Expand fashion operations across
                    multiple stores, locations, and
                    digital channels easily.

                </p>


            </div>





        </div>





    </div>



</section>








{/* =====================================================
        FOOTER
===================================================== */}


<Footer />



        </>

    );

};



export default Fashion;